import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import logoUrl from "@/assets/mission-ready-logo.webp";

export function Logo({ className = "", showWordmark = true }: { className?: string; showWordmark?: boolean }) {
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`}>
      <img
        src={logoUrl}
        alt="Mission Ready"
        className="h-12 w-12 sm:h-14 sm:w-14 object-contain drop-shadow-[0_0_14px_rgba(220,38,38,0.55)]"
      />
      {showWordmark && (
        <span className="font-display text-lg sm:text-xl font-bold uppercase tracking-[0.18em] text-foreground">
          {/* Logotype: brand red is exempt from text contrast rules (WCAG 1.4.3 logotype). */}
          Mission<span className="text-primary mr-logotype"> Ready</span>
        </span>
      )}
    </Link>
  );
}

export function PageContainer({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>;
}
